// extracted by mini-css-extract-plugin
module.exports = {"icon":"MainIcon_icon__jGbBm"};